/* eslint-disable no-nested-ternary */
import {
  Box,
  Button,
  TextField,
  Select,
  InputLabel,
  MenuItem,
} from '@material-ui/core';
import { rgba } from 'polished';
import styled from 'styled-components';

export const ContentContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 64px - 50px);
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-color: ${(props) =>
    props.backgroundColor || 'var(--color-blue-primary)'};
  background-image: url(${(props) => props.backgroundImage});
  background-size: ${(props) => props.backgroundSize || 'contain'};

  @media (max-width: 768px) {
    background-image: url(${(props) => props.mobileBackgroundImage});
    background-size: ${(props) => props.backgroundMobileSize || 'contain'};
  }
`;

export const MainContainer = styled(Box)`
  display: flex;
  width: 400px;
  min-height: 200px;
  position: relative;
  background-color: ${(props) => props.backgroundcolor || '#fff'};
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin: 20px 20px;
  border-radius: 10px;

  @media (max-width: 450px) {
    width: 300px;
    height: auto;
  }

  @media (max-width: 350px) {
    width: 200px;
    height: auto;
  }

  @media (max-height: 500px) {
    min-height: 0;
  }
`;

export const MainContainerTitle = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${(props) => props.padding || '20px 0 0 0'};
  text-align: center;
  width: 100%;
`;

export const CustomButton = styled(Button)`
  width: ${(props) => props.width || '100%'};
  min-height: 50px;
  background-color: ${(props) =>
    props.styleType === 'outlined'
      ? props.disable
        ? '#808080' || 'var(--color-blue-primary)'
        : props.secondaryColor || 'var(--color-blue-primary)'
      : props.disable
      ? '#808080' || 'var(--color-blue-primary)'
      : props.color || 'var(--color-blue-primary)'};
  color: #fff;
  text-transform: none;
  border: ${(props) =>
    props.styleType === 'outlined'
      ? props.disable
        ? '1px solid #808080'
        : `1px solid ${props.color}`
      : 'none'};
  cursor: ${(props) => (props.disable ? 'default' : 'pointer')};

  &:hover {
    background-color: ${(props) =>
      props.disable
        ? '#808080'
        : props.styleType === 'outlined'
        ? rgba(props.color, 0.1) || 'var(--color-blue-50)'
        : rgba(props.color, 0.9) || 'var(--color-blue-50)'};
  }
`;

export const CustomSeparator = styled(Box)`
  height: 10px;
`;

export const FormInputsContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 5px;
`;

export const CustomTextField = styled(TextField)`
  & input {
    color: ${(props) => props.bordercolor || 'var(--color-blue-primary)'};
  }
  & label {
    color: ${(props) =>
      props.bordercolor
        ? rgba(props.bordercolor, 0.8)
        : 'var(--color-blue-primary)'};
  }
  & label.Mui-focused {
    color: ${(props) => props.bordercolor || 'var(--color-blue-primary)'};
  }
  & .MuiOutlinedInput-root {
    fieldset {
      border-color: ${(props) =>
        props.bordercolor
          ? rgba(props.bordercolor, 0.8)
          : 'var(--color-blue-primary)'};
    }
    &.Mui-focused fieldset {
      border-color: ${(props) =>
        props.bordercolor || 'var(--color-blue-primary)'};
    }
    &:hover fieldset {
      border-color: ${(props) =>
        props.bordercolor || 'var(--color-blue-primary)'};
    }
    &.MuiFilledInput-underline:before {
      border-bottom: 1px solid
        ${(props) => props.bordercolor || 'var(--color-blue-primary)'};
    }
    &.MuiFilledInput-underline:after {
      border-bottom: 2px solid
        ${(props) => props.bordercolor || 'var(--color-blue-primary)'};
    }
  }

  input:-webkit-autofill,
  input:-webkit-autofill:focus {
    transition: background-color 600000s 0s, color 600000s 0s;
  }
  input[data-autocompleted] {
    background-color: transparent !important;
  }
`;

export const CustomSelect = styled(Select)`
  .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) =>
      props.bordercolor
        ? rgba(props.bordercolor, 0.8)
        : 'var(--color-blue-primary)'};
  }
  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) =>
      props.bordercolor || 'var(--color-blue-primary)'};
  }
  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) =>
      props.bordercolor || 'var(--color-blue-primary)'};
  }
  & .MuiSvgIcon-root {
    fill: ${(props) =>
      props.bordercolor || 'var(--color-blue-primary)'} !important;
  }
  & .MuiSelect-root {
    color: ${(props) => props.bordercolor || 'var(--color-blue-primary)'};
  }

  input:-webkit-autofill,
  input:-webkit-autofill:focus {
    transition: background-color 600000s 0s, color 600000s 0s;
  }
  input[data-autocompleted] {
    background-color: transparent !important;
  }
`;

export const CustomInputLabel = styled(InputLabel)`
  color: ${(props) =>
    props.textcolor ? rgba(props.textcolor, 0.8) : 'var(--color-blue-primary)'};
  &.Mui-focused {
    color: ${(props) => props.textcolor || 'var(--color-blue-primary)'};
  }
`;

export const CustomMenuItem = styled(MenuItem)``;

export const CustomForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

export const CustomFormError = styled.p`
  color: red;
  font-size: 12px;
  margin: 0;
  padding: 0;
`;

export const FormRowTextFildsContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
